angular.module('bmsApp.settings').controller('VATRateCtrl',
	function ($scope, $log, VATRateSvc, TaxCodeSvc, notify, $q) {

		$scope.processing = false;
		$scope.vatRates = [];
		var promises = [];
		promises.push(VATRateSvc.index());
		promises.push(TaxCodeSvc.index());


		$q.all(promises)
			.then(function (responses) {
				$scope.vatRates = responses[0].data.vat_rate_collection;
				$scope.taxCodes = responses[1].data.t_code_collection;
			});

		$scope.setEditable = function (setting) {
			setting.editing = true;

		};
		$scope.cancelEditing = function (setting) {
			setting.editing = false;
		};

		$scope.save = function (setting) {
			setting.editing = false;
		};

		$scope.delete = function (setting, index) {
			if (setting.newlyAdded) {
				$scope.salesTypes.splice(index, 1);
			}
			else {
				setting.deleted = true;
			}
		};

		$scope.reinstate = function (setting) {
			setting.deleted = false;
		};

		$scope.addNew = function () {
			var obj = {id: '', tax_code: {}, deleted: false};
			$scope.vatRates.push(obj);
			obj.editing = true;
			obj.newlyAdded = true;
		};

		$scope.submit = function (data) {
			$scope.processing = true;
			VATRateSvc.update(data)
				.then(function (response) {
					console.log(response);
					notify({
						message: 'List saved'
					});
				}, function (error) {
					$scope.errors = error;
				})
				.finally(function () {
					$scope.processing = false;
				});

		};

	});



